import { render, staticRenderFns } from "./CloseProduct.vue?vue&type=template&id=5caab553&"
import script from "./CloseProduct.vue?vue&type=script&lang=js&"
export * from "./CloseProduct.vue?vue&type=script&lang=js&"
import style0 from "./CloseProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports